import { render } from "./teaStudioManager.vue?vue&type=template&id=c918c65e&scoped=true"
import script from "./teaStudioManager.vue?vue&type=script&lang=js"
export * from "./teaStudioManager.vue?vue&type=script&lang=js"

import "./teaStudioManager.vue?vue&type=style&index=0&id=c918c65e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c918c65e"]])

export default __exports__